import { ca } from '@cian/analytics';

import { IJsonQuery } from 'shared/json_query';

export function trackBannersShow(sc: IJsonQuery) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'trap',
    label: 'csp_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер загородки десктоп',
        trapid: 'Баннер загородки десктоп',
      },
    },
    sc,
    useLastProducts: true,
  });
}

export function trackBannerKpLinkClick(sc: IJsonQuery) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'trap',
    label: 'csp_banner',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер загородки десктоп (КП)',
        trapid: 'Баннер загородки десктоп (КП)',
      },
    },
    sc,
    useLastProducts: true,
  });
}

export function trackTrapKpLinkClick(sc: IJsonQuery) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'trap',
    label: 'csp_banner',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер загородки десктоп (Ловушка КП)',
        trapid: 'Баннер загородки десктоп (Ловушка КП)',
      },
    },
    sc,
    useLastProducts: true,
  });
}

export function trackBannerBuildersClick(sc: IJsonQuery) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'trap',
    label: 'csp_banner',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер загородки десктоп (Построить дом)',
        trapid: 'Баннер загородки десктоп (Построить дом)',
      },
    },
    sc,
    useLastProducts: true,
  });
}
